// extracted by mini-css-extract-plugin
export default {"bookNowBtn":"BookNowBtn_bookNowBtn__CpOVG","button":"BookNowBtn_button__ZyFxU"};